import { getEntityRef } from "@client/content/lib/helper";
import Modal from "@client/controls/Modal/container";
import { type EntityRef } from "@client/types";
import SubmitButton from "@common/controls/Form/Buttons/Submit";
import { FormButtons, FormControlled } from "@common/controls/Form/component";
import { getDialCode } from "@common/controls/Inputs/PhoneInput/lib";
import { type FormModalControlledRenderParams } from "@common/controls/Modal/Modals/Form/component";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import { type Leaderboard } from "../../../types";
import Header from "../../ModalHeader/container";
import ProfileFields from "../../ProfileFields/container";

export type MapProps = EntityRef & {
  error: string | null;

  isEditMode: boolean;
  countryCode: string | null;
  isSubmitting: boolean;
  isUserKnown: boolean;
  item: Leaderboard.Item;
};

export interface ActionProps {
  onClose: () => void;
  onSubmit: (data: Leaderboard.View.UserData | null) => void;
}

export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  const onSubmit = React.useCallback(
    (data: Leaderboard.View.UserData) => {
      if (props.isUserKnown) {
        props.onSubmit(null);
      } else {
        props.onSubmit(data);
      }
    },
    [props.isUserKnown, props.onSubmit]
  );

  const defaultValues = React.useMemo(
    (): Partial<Leaderboard.View.UserData> => ({
      telephone: getDialCode(props.countryCode) ?? undefined
    }),
    [props.countryCode]
  );

  return (
    <Modal
      className="cartly_content_leaderboard_vote first"
      hasBackdrop
      isAdminColor={false}
      isDraggable={false}
      isCentered
      isInViewport
      isLoading={false}
      isVisible={true}
      width={500}
      onClose={props.onClose}
      closeBehaviour={props.isSubmitting ? "not-allowed" : undefined}
    >
      <Modal.Header>
        {({ onCloseClick }) => <Header onCloseClick={onCloseClick} id={props.id} item={props.item} />}
      </Modal.Header>
      <Modal.Body>
        <FormControlled defaultValues={defaultValues} submit={onSubmit}>
          {({ values }: FormModalControlledRenderParams<Leaderboard.View.UserData>) => (
            <>
              {(!props.isUserKnown || props.isEditMode) && <ProfileFields {...getEntityRef(props)} values={values} />}

              <FormButtons>
                <SubmitButton>{i18n.submitVote}</SubmitButton>
              </FormButtons>
            </>
          )}
        </FormControlled>
      </Modal.Body>
    </Modal>
  );
};
